<mat-form-field appearance="outline" subscriptSizing="dynamic">
  @if (label) {
  <mat-label>{{ label }}</mat-label>
  }
  <mat-icon matPrefix svgIcon="search"></mat-icon>

  <input
    matInput
    type="text"
    [placeholder]="placeholder"
    [formControl]="control"
  />

  @if (control.value) {
  <button matSuffix mat-icon-button (click)="control.reset()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
  }
</mat-form-field>
